

/*
	This file contains Javascript wrapper classes that correspond closely to their easyforms counterparts.
*/

export function _installListenerOnEach(elementsRef, listenScript) {
    let i = 0;
    for (i = 0; i < elementsRef.length; i++) {
        let anElement = elementsRef[i];

        //if select, then onchange
        // else onkeyup and onchange

        //Ignore elements that don't have a 'name' attribute because
        // they are not truly a form input that is uploaded to the server.
        // This simplifies things for item choosers because the two <select> lists
        // and all the filtering options are not actually submitted to the server
        // and thus they should not trigger a "change" on the form
        if (anElement.name) {
            if (anElement.tagName == "SELECT") {
                ef_prependOnChangeHandler(anElement, listenScript);
            } else if (anElement.type == 'radio' || anElement.type == 'checkbox') {
                //For radio buttons we use onclick rather than onchange to work around
                //an IE issue: the first change of the radio option does not fire onchange!

                //Update: also do this for checkboxes because IE doesn't fire the onchange until the checkbox loses focus
                ef_prependOnClickHandler(anElement, listenScript);
            } else {
                // onkeyup() captures most events. onchange() is used as a safety net.
                // onkeyup() misses the paste of text from a right-click contextual menu. onchange() catches this when the field looses focus.

                //bugfix: don't fire the listener for key presses that don't change the text!
                if (anElement.type == 'text') {
                    anElement.ef_prev_value = anElement.value;

                    let funcMaker = function(textInput) { //must use a generator function because anElement changes every iteration
                        return function() {
                            if (textInput.ef_prev_value != textInput.value) {
                                textInput.ef_prev_value = textInput.value;
                                listenScript();
                            }
                            //else key press did not result in a change
                        };
                    };

                    ef_prependOnKeyupHandler(anElement, funcMaker(anElement));
                } else
                    ef_prependOnKeyupHandler(anElement, listenScript);

                ef_prependOnChangeHandler(anElement, listenScript);

                // this only gets applied to two buttons on the form
                let isItemChooserButton = anElement.name.indexOf("IC_btn") == 0;
                if (isItemChooserButton)
                    ef_prependOnClickHandler(anElement, listenScript);
            }
        }
    }
}


export function ef_installFormChangeListener(listenScript) {
    // Get all "input", "select" and "textarea" elements and set
    // the onchange(), onkeyup() or onclick() functions to 'listenScript'.

    _installListenerOnEach(document.getElementsByTagName("input"), listenScript);
    _installListenerOnEach(document.getElementsByTagName("select"), listenScript);
    _installListenerOnEach(document.getElementsByTagName("textarea"), listenScript);
}

export function ef_installFormChangeListenerForForm(form, listenScript) {
    // Get all "input", "select" and "textarea" elements for the provided form and set
    // the onchange(), onkeyup() or onclick() functions to 'listenScript'.

    _installListenerOnEach(form.getElementsByTagName("input"), listenScript);
    _installListenerOnEach(form.getElementsByTagName("select"), listenScript);
    _installListenerOnEach(form.getElementsByTagName("textarea"), listenScript);
}


/**add a function to be called when an element is changed.  If the element already
 has an onchange() function then the new function will be called before the existing.*/
export function ef_prependOnChangeHandler(elmRef, aFunction) {
    //add the hooks array to the form object if necessary
    if (!elmRef.onChangeHooks) {
        if (elmRef.onchange) {
            //first handler will be the current onsubmit function
            elmRef.onChangeHooks = [elmRef.onchange];
        } else {
            elmRef.onChangeHooks = [];
        }
        //new onsubmit is our helper function
        elmRef.onchange = _efDoHookedOnChange;
    }

    //tack on another function to the hook list
    elmRef.onChangeHooks[elmRef.onChangeHooks.length] = aFunction;
}

export function _efDoHookedOnChange() {
    //call hooks in reverse...
    let i = this.onChangeHooks.length;

    let lastResult;
    while (i > 0) {
        i--;
        if (this.onChangeHooks[i] != null) {
            lastResult = this.onChangeHooks[i]();
            if (lastResult) {
                // uninstall the listener if it returns TRUE
                this.onChangeHooks[i] = null;
            }
        }
    }
    return lastResult;
}

/**add a function to be called when an element is changed.  If the element already
 has an onkeyup() function then the new function will be called before the existing.*/
export function ef_prependOnKeyupHandler(elmRef, aFunction) {
    //add the hooks array to the form object if necessary
    if (!elmRef.onKeyUpHooks) {
        if (elmRef.onkeyup) {
            //first handler will be the current onkeyup() function
            elmRef.onKeyUpHooks = [elmRef.onkeyup];
        } else {
            elmRef.onKeyUpHooks = [];
        }
        //new onkeyup is our helper function
        elmRef.onkeyup = _efDoHookedOnKeyup;
    }

    //tack on another function to the hook list
    elmRef.onKeyUpHooks[elmRef.onKeyUpHooks.length] = aFunction;
}

export function _efDoHookedOnKeyup() {
    //call hooks in reverse...
    let i = this.onKeyUpHooks.length;

    let lastResult;
    while (i > 0) {
        i--;
        if (this.onKeyUpHooks[i] != null) {
            lastResult = this.onKeyUpHooks[i]();
            if (lastResult) {
                // uninstall the listener if it returns TRUE
                this.onKeyUpHooks[i] = null;
            }
        }
    }
    return lastResult;
}

/**add a function to be called when an element is clicked.  If the element already
 has an onclick() function then the new function will be called before the existing.*/
export function ef_prependOnClickHandler(elmRef, aFunction) {
    //alert("adding onclick");
    //add the hooks array to the form object if necessary
    if (!elmRef.onClickedHooks) {
        if (elmRef.onclick) {
            //first handler will be the current onclick function
            elmRef.onClickedHooks = [elmRef.onclick];
        } else {
            elmRef.onClickedHooks = [];
        }
        //new onclick is our helper function
        elmRef.onclick = _efDoHookedOnClick;
    }

    //tack on another function to the hook list
    elmRef.onClickedHooks[elmRef.onClickedHooks.length] = aFunction;
}

export function _efDoHookedOnClick() {
    //call hooks in reverse...
    let i = this.onClickedHooks.length;

    let lastResult;
    while (i > 0) {
        i--;
        if (this.onClickedHooks[i] != null) {
            lastResult = this.onClickedHooks[i]();
            if (lastResult) {
                // uninstall the listener if it returns TRUE
                this.onClickedHooks[i] = null;
            }
        }
    }
    return lastResult;
}

/**If you have a reference to one of the inputs in an easyforms InputArray, this function
 gets you a different input given its index*/
export function ef_getInputArrayElement(anyElement, desiredIndex) {
    //There are 2 cases to handle:
    // 1) the InputArray contains concrete inputs like TextField or Select
    // 2) the InputArray contains composite inputs like a Subform

    let elmName = anyElement.name;
    let desiredName = null;

    //Case 1: "myArray_99"  (remember we dont know what comes before myArray - we could have arrays of arrays)
    let pat1 = /_\d+$/;
    let match = pat1.exec(elmName);
    if (match) {
        let prior = elmName.substring(0, match.index);
        desiredName = prior + "_" + desiredIndex;
    } else {
        //Case 2: "myArray_99_selType" (remember we dont know what comes before myArray - we could have arrays of arrays)
        let pat2 = /\d+_[^_]+$/;
        match = pat2.exec(elmName);
        if (match) {
            let prior = elmName.substring(0, match.index);
            let remain = elmName.substring(elmName.lastIndexOf('_'));
            desiredName = prior + desiredIndex + remain;
        }
    }

    if (desiredName)
        return anyElement.form[desiredName];
    else
        return null;

}